import { motion } from "framer-motion";
import { useEventListener } from "hooks";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { IpodEvent } from "utils/events";

import { Point } from "./CoverFlow";
const YTPlayer = require("yt-player");

const getOffsetPx = (offset: number, midpoint: number) => {
  if (offset === 0) return 0;
  const val = midpoint - 46 + offset * 48;

  return val + (offset < 0 ? -48 : 24);
};

interface ContainerProps {
  isActive: boolean;
  isSelected: boolean;
  isPlaying: boolean;
  isHidden: boolean;
  midpoint: Point;
  offset: number;
  index: number;
  activeIndex: number;
}

const Container = styled.div.attrs((props: ContainerProps) => ({
  style: {
    background: "transparent",
    backgroundSize: "cover",
  },
}))<ContainerProps>`
  z-index: ${(props) => 1 - Math.abs(props.index - props.activeIndex)};
  position: absolute;
  height: 8em;
  width: 8em;
  transition: transform 0.25s, opacity 0.35s, background 0.35s;
  transform-style: preserve-3d;
  -webkit-box-reflect: below 0px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(70%, transparent), to(rgba(240, 240, 240, 0.2)));
  opacity: ${(props) => props.isHidden && 0};

  ${(props) =>
    props.isActive &&
    css`
      transition: transform 0.3s, opacity 0.35s, background 0.35s;
      transform: translate3d(${props.midpoint.x - 60}px, 4px, 20px)
        ${props.isSelected && "translateX(-20.5%) translateY(1.5%) scale(2.05)"};

      ${props.isSelected &&
      css`
        transition: transform 0.5s, opacity 0.35s, background 0.35s;
        -webkit-box-reflect: none;

        ${Artwork} {
          opacity: 0;
        }
      `};

      ${props.isPlaying &&
      css`
        transform: translate(${props.midpoint.x / 6}px, -10px) rotateY(18deg);

        ${Artwork} {
          opacity: 1;
        }
      `};
    `};

  ${(props) =>
    !props.isActive &&
    css`
      transform: translateX(${props.offset}px) scale(1.1) translateZ(-65px)
        rotateY(${props.index < props.activeIndex ? "70deg" : "-70deg"});
    `};
`;

const Artwork = styled.img`
  z-index: 0;
  position: absolute;
  height: 130px;
  width: 150px;
  transition: opacity 0.5s;
`;

const Backside = styled(motion.div)`
  position: relative;
  height: 100%;
  width: 100%;
`;

interface Props {
  index: number;
  activeIndex: number;
  midpoint: Point;
  album: IpodApi.Album;
  isSelected: boolean;
  playingAlbum: boolean;
  setPlayingAlbum: (val: boolean) => void;
  videoId?: string;
  title?: string;
  author?: string;
  thumbnail?: string;
}

const AlbumCover = ({
  album,
  midpoint,
  index,
  activeIndex,
  isSelected,
  playingAlbum,
  setPlayingAlbum,
  videoId,
  title,
  author,
  thumbnail,
}: Props) => {
  const isVisible = index > activeIndex - 15 && index < activeIndex + 15;
  const isActive = index === activeIndex;
  const offset = getOffsetPx(index - activeIndex, midpoint.x);
  const isHidden = !isActive && playingAlbum;
  const [player, setPlayer] = useState<any>();

  useEffect(() => {
    const player_aux = new YTPlayer(`#player_${videoId}`, {
      modestBranding: true,
      controls: false,
      annotations: false,
      fullscreen: false,
      related: false,
      playsInline: true,
    });
    setPlayer(player_aux);
  }, []);

  useEffect(() => {
    if (player) {
      player.load(videoId);
      player.setSize(150, 130);
    }
  }, [player]);

  useEffect(() => {
    if (isSelected) {
      player.play();
    } else if (player) {
      player.stop();
    }
  }, [isSelected]);

  const handlePlayPauseClick = () => {
    if (player.getState() === "playing") {
      player.pause();
    } else if (isSelected) {
      player.play();
    }
  };

  useEventListener<IpodEvent>("playpauseclick", handlePlayPauseClick);

  return isVisible ? (
    <Container
      isActive={isActive}
      isSelected={isSelected}
      isHidden={isHidden}
      midpoint={midpoint}
      offset={offset}
      index={index}
      activeIndex={activeIndex}
      isPlaying={isSelected && playingAlbum}
    >
      <Artwork src={thumbnail} />
      <div id={`player_${videoId}`}></div>

      <div
        style={{
          transition: ".3s",
          opacity: isActive && !isSelected ? 0.8 : 0,
          fontSize: "10px",
          position: "fixed",
          left: "-40px",
          right: "-40px",
          marginTop: "10px",
        }}
      >
        {title} <br />
        <b>{author}</b>
      </div>

      {/* <AnimatePresence>
        {isSelected && !playingAlbum && (
          <Backside {...fadeScale}>
            <BacksideContent
              albumId={album.id}
              setPlayingAlbum={setPlayingAlbum}
            />
          </Backside>
        )}
      </AnimatePresence> */}
    </Container>
  ) : null;
};

export default AlbumCover;
